
const zoekWerknemer = {

	init() {

		// Focus op naam veld als pagina geladen wordt
		$(function() {
			$('#naam').focus();
		});

		// Zoekfunctie
		$('button.zoek-werknemer-knop').click(function() {

			// Verberg 'geen resultaten text'
			$('.geen-resultaten').addClass('d-none');

			// Toon resultaten formulier
			$('#form_suggestion').removeClass('d-none');

			// Definieer form data object
			var formData = {
				naam: $('form.zoek-scherm input#naam').val(),
				//geboorte_datum: $('form.zoek-scherm input#geboorte_datum').val(),
				geslacht: $('form.zoek-scherm select#geslacht').val(),
			};

			// Ajax functie
			$.ajax({
				url: window.app.ajaxPath + $('form.zoek-scherm').data('administratie_relatie_id') + '/zoek/',
				type: 'POST',
				data: formData,
				success: function(data) {

					// Loop door de zoekresultaten
					if (data.werknemers.length == data.aantal) {
						// Toon 'geen resultaten' text als er gen resultaten zijn
						$('.btn-werknemer-toevoegen').addClass('d-none');
						$('#list-group-accordion').removeClass('d-none');
						$('#form_suggestion h4').removeClass('d-none');
						if (!data.werknemers.length) {
							$('.geen-resultaten').removeClass('d-none');
							$('.btn-werknemer-toevoegen').removeClass('d-none');
							$('#list-group-accordion').addClass('d-none');
							$('#form_suggestion h4').addClass('d-none');
						}
						$('div.list-group-results span.list-group-item').remove();
						$.each(data.werknemers, function(key, werknemer) {
							$.each(werknemer, function(keyw, value) {
								$('div#collapseWerknemerTemplate span.list-group-item span.' + keyw).html(value);
							});
							$('div#collapseWerknemerTemplate span.list-group-item .list-group-item-details').attr('id', 'collapseResult' + key);
							$('div#collapseWerknemerTemplate span.list-group-item').attr('aria-controls', 'collapseResult' + key);
							$('div#collapseWerknemerTemplate span.list-group-item').attr('href', '#collapseResult' + key);
							$('div#collapseWerknemerTemplate span.list-group-item').attr('data-werknemer_id', werknemer.werknemer_id);

							// medling ID melding_id
							$('div#collapseWerknemerTemplate button, div#collapseWerknemerTemplate span.label-bestaande-melding').hide(0);
							if (werknemer.melding_id != '') {
								$('div#collapseWerknemerTemplate .visible-bestaande-melding').show(0);
							} else {
								$('div#collapseWerknemerTemplate .visible-geen-bestaande-melding').show(0);
							}

							$('div#collapseWerknemerTemplate span.list-group-item').clone().appendTo('div.list-group-results');

						});
					}
				},
				error: function() {
					$('div.list-group-results span.list-group-item').remove();
					$('.geen-resultaten').removeClass('d-none');
				}
			});
		});

		// Click functie voor knoppen gevonden werknemers
		$('.gevonden-werknemers').on('click', 'button', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var w = $(this).closest('span').data('werknemer_id');
			var p = $(this).attr('url');
			window.location.href = (p + w);
		});

		// Accordion functie voor gevonden werknemers
		$('.gevonden-werknemers').on('click', 'span.list-group-item', function() {
			$('.gevonden-werknemers .fa').removeClass('fa-caret-down').addClass('fa-caret-right');
			if ($(this).attr('aria-expanded') == 'true') {
				$(this).find('.fa').removeClass('fa-caret-down').addClass('fa-caret-right');
			} else {
				$(this).find('.fa').removeClass('fa-caret-right').addClass('fa-caret-down');
			}
			$('.list-group-item-details').collapse('hide');
		});

		// Click zoek button als gebruiker op enter toets drukt
		$('.form-section input, .form-section select').keyup(function(e) {
			if (e.keyCode === 13) {
				$('button.zoek-werknemer-knop').click();
			}
		});

	}

};

export default zoekWerknemer;

